import { render, staticRenderFns } from "./DrinkingWaterWriteBody.vue?vue&type=template&id=793b295a&scoped=true"
import script from "./DrinkingWaterWriteBody.vue?vue&type=script&lang=js"
export * from "./DrinkingWaterWriteBody.vue?vue&type=script&lang=js"
import style0 from "./DrinkingWaterWriteBody.vue?vue&type=style&index=0&id=793b295a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793b295a",
  null
  
)

export default component.exports